import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/story", element: <Navigate to="/#about" replace /> },
  { path: "/investing", element: <Navigate to="/#investments" replace /> },
  { path: "/building", element: <Navigate to="/#how-we-work" replace /> },
  { path: "/advisory", element: <Navigate to="/#contact" replace /> },
  { path: "*", element: <NotFound /> },
];

export default routes;